<template>
	<div id="content">
		<shutter-panel ref="shutterPanel" />
	</div>
</template>

<script type="text/javascript">
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"

	export default {
		name: 'StallionCampagne',
		mixins: [ShutterCongelation],
		props: ['horse_id'],
		mounted() {
			this.setUpCampagneStallionListe(this.horse_id)
		},
	}
</script>